'use strict';

import QueryBuilder from './QueryBuilder';
import ModelQuery   from './ModelQuery';

export default class Model { 
    
    static fields() {
        return 'id';
    }

    static defaultConnection() {
        return '';
    }

    static create() {
        return new (this);
    }

    fill(data) {
        for( let index in data) {
            if( ! data.hasOwnProperty(index) ) {
                continue;
            }
            this[index] = data[index];
        }

        return this;
    }

    static all(args) {
        args.filters = {};
        return this.query(args);
    }

    static query(args) {

        let name             = this.name;
        let connectionName   = this.defaultConnection();
        let fields           = this.fields(); 


        if( ! args.hasOwnProperty('filters') ) {
            args = { filters : args };
        }

        let qb = new QueryBuilder();

        let query = qb.fields(fields)
            .connection(connectionName)
            .args(args)
            .edgesQuery();
        
        return new ModelQuery(this, query.gql(), query.variables())
    }    
}


// WEBPACK FOOTER //
// ./src/graphql/Model.js